export default __webpack_public_path__ + "static/media/tvpublicitaria.8d09d0d9.png";